import { render, staticRenderFns } from "./WonderYjjRateJX.vue?vue&type=template&id=4a74f8a4"
import script from "./WonderYjjRateJX.vue?vue&type=script&lang=js"
export * from "./WonderYjjRateJX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports